import './App.css';
import Weather from './Components/Weather';

function App() {
  return (
    <div className="App" >
      <div></div>
        <Weather />
    </div>
  );
}

export default App;
